module.exports = __webpack_public_path__ + "static/media/North Korea.4969ee6a.png";